import { Config, Environment } from './config';

export const config: Config = {
  variables: {
    graphDriveId: 'b!QNqndrwLI0iWQo1VyWzJnk5h1NGNNaZFpTPFHdpr0B3PnEIyxoBtQbkOr4lwvMyE',
    sharedResourceFolderId: '015MSVGKXM5MNC45E3RJAJVBSQQK65NSLN',
    graphBaseUrl: 'https://daas-dev-sidecar4e7882ef.blacktree-c8e1a9a1.uksouth.azurecontainerapps.io/proxy',
    mspsFolderId: '015MSVGKWR2QUKXM3BFRCL2FNR3LL77NY6',
    listId: '32429ccf-80c6-416d-b90e-af8970bccc84',
    siteId: '76a7da40-0bbc-4823-9642-8d55c96cc99e',
    listDeploymentMetadata:
      '{"lists":{"drive":{"columns":{"msp":{"hash":"b9afc817d949a649812931e38599cd593d3e05dae39e1c7032ffcb10bd9f787f","id":"4a54625c-6e0e-4d57-b7b6-888046ebcd5d","name":"_x004d_sp001"},"name":{"hash":"3fe85a632bce28d075a2ec9d88a64a68cdf2df3f5c4fc60d004cc2bdb33353f5","id":"1833cee6-5b92-4a2d-b34e-a484db6cc0b3","name":"Name001"}},"id":"32429ccf-80c6-416d-b90e-af8970bccc84","name":"drive","siteId":"76a7da40-0bbc-4823-9642-8d55c96cc99e"}}}',
    cmsBaseUrl: 'https://daas-dev-api492bdbba.blacktree-c8e1a9a1.uksouth.azurecontainerapps.io',
    clientId: '8c22949b-d79c-478a-af86-b494aef3eb9d',
    signUpPolicy: 'B2C_1A_SIGNUP_DEV',
    signInPolicy: 'B2C_1A_SIGNUP_SIGNIN_DEV',
    claimEnvironment: Environment.Development,
    appInsightsConnectionString:
      'InstrumentationKey=800af819-2719-409f-bb69-0efeda0802b6;IngestionEndpoint=https://insights.si.services/;LiveEndpoint=https://uksouth.livediagnostics.monitor.azure.com/',
    apiClientId: 'd7f7cf49-c8a6-4df4-b151-346cc98ea9a8',
    apiScope: 'DaaSAPI.Default',
    authority: 'https://daasportal.b2clogin.com',
    tenant: 'daasportal.onmicrosoft.com',
    //apiBaseUrl: 'https://daas-dev-api492bdbba.blacktree-c8e1a9a1.uksouth.azurecontainerapps.io',
    apiBaseUrl: 'http://localhost:7101',
    supportEmail: 'support@daasportal.app',
    imageBaseUrl: 'https://daasdevblob49c77fab.blob.core.windows.net/assets',
    logosBaseUrl: 'https://daasdevblob49c77fab.blob.core.windows.net/logos',

    intercomAppId: 'xm1zzj11',
    loqateApiKey: import.meta.env.VITE_LOQATE_API_KEY
  },
  flags: {}
};
